import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction} from '../../redux/actions/MainAction'

class ChooseMethodModal extends Component {

    

    constructor(props) {
        super(props)

        this.state = {
            ...props
        }
       
    }
    
    handleSubmit(event,source,isSubmit,status)
    {
        console.log(status);
        this.props.onHandleSubmit(event,source, isSubmit, status);
    }

    getRpaShowState(){
        
        const {
            po_no,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT
        } = this.props
        
        let is_rpa = true 

        let is_profit_segment = false
        let is_subcontracting = false
        let is_purchase_consumption = false 

        //Case : Profit segment
        // Item Assg. :  J 
        // Item Cat. : ทุกค่า
        t_GR_ITEM.forEach(item => {
            if(item.a==="J" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_profit_segment = true
            }
        });
        
        //Case : Subcontracting
        // Item Assg. : ทุกค่า
        // Item Cat. : L  
        t_GR_ITEM.forEach(item => {
            if(item.i==="L" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_subcontracting = true
            }
        });

        //Case : Purchase consumption
        // Contract 41* 
        // Purchase consumption (F,-) 
        // BOT ไม่รองรับกรณีเฉพาะที่เป็น multiple account assignment
        // Item Assg. :  F
        // Item Cat. : - 
        let is_f = false
        let is_multiple_account_assignment = false
        let is_contract= po_no && po_no.startsWith('41')
        
        t_GR_ITEM.forEach(item => {
            if(item.a==="F" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_f = true
            }
        });
        
        is_multiple_account_assignment = (t_GR_ITEM_ACCOUNT_ASSIGNMENT.length > 1);
        var key = ""
        t_GR_ITEM_ACCOUNT_ASSIGNMENT.forEach(item => {
            if(key!== item.item_no)
            {
                key = item.item_no
              is_multiple_account_assignment = false
            }
            else
            {
              is_multiple_account_assignment = true
              return
            }
            });
        is_purchase_consumption = is_contract && is_f &&is_multiple_account_assignment;

        is_rpa = is_rpa && !is_profit_segment && !is_subcontracting && !is_purchase_consumption
            
        return is_rpa
    }
    

    render() {
       
        const { transaction } = this.props


        let is_rpa = this.getRpaShowState()
       
        return (
            <div className="modal fade sp-modal rrs-modal" id="ChooseMethodModal" tabIndex={-1} role="dialog" aria-labelledby="ChooseMethodModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="ChooseMethodModalLabel">เลือกวิธีการ</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">
                            <h5 className="modal-title" align="center">กรุณาเลือกวิธีการดำเนินการต่อไป</h5>
                            
                            <div className="col-12 sp-header-button-panel2">
                            
                                <button className="btn btn-info bt-rpa" data-dismiss="modal" aria-label="Close" disabled={is_rpa == true ? false : true } onClick={(event) => { this.handleSubmit(event,this, true, "RPA") }}>
                                    RPA
                                </button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <button className="btn btn-secondary bt-manualy" data-dismiss="modal" aria-label="Close" onClick={(event) => { this.handleSubmit(event,this, true, "Manualy") }}>
                                    Manually
                                </button>

                            </div>

                            <div className="col-12 sp-header-button-panel2">
                                <h5 className="modal-title required" align="center">{is_rpa==true ? "" : "*ไม่สามารถส่งข้อมูลแบบ RPA ได้"}</h5>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux} = state
    return {
      transaction: MainRedux.transaction,
      t_GR_ITEM: MainRedux.t_GR_ITEM,
      t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
      po_no: MainRedux.po_no,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      //saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChooseMethodModal)